module.exports = __webpack_public_path__ + "components/flag/static/square/gl-9a85e6f9d9892edf5144694fc5fa892d.svg";